module.exports = __webpack_public_path__ + "img/1.6c4fd3b0.png";